import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Header from "../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import SearchInput from "../ShareElements/SearchInput/SearchInput";
import TableFilter from "../ShareElements/TableFilter/TableFilter";
import "../../../../Assets/Styles/EmpPosList.scss";
import "../../../../Assets/Styles/Pagination.scss";
import { Config } from "../../../../Config";
import Pencil from "../../../../Assets/Images/pencil.svg";
import axios from "axios";
import EmptyState from "../ShareElements/EmptyState/FormEmptyState";
import Collapsible from "react-collapsible";
import Select from "../ShareElements/Select/Select";

const EmployeesList = (props) => {
  const Colors = [
    { bg: "#B9D3FA", text: "#6DA2F2" },
    { bg: "#FFE0E0", text: "#DE8C8C" },
    { bg: "#CDFFCC", text: "#68D966" },
    { bg: "#FFFFC2", text: "#D6D65E" },
    { bg: "#E1CFFF", text: "#A781E3" },
    { bg: "#E4F7F2", text: "#71D9BB" },
    { bg: "#FFE3B3", text: "#D9B16C" },
    { bg: "#D1F0FF", text: "#60B3DB" },
  ];
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [PageData, setPageData] = useState([]);
  const [Pages, setPages] = useState([]);
  const [TotalElements, setTotalElements] = useState();
  const [FilterIds] = useState([
    "Employee-sort-pointer-up",
    "Employee-sort-pointer-down",
    "Country-sort-pointer-up",
    "Country-sort-pointer-down",
    "City-sort-pointer-up",
    "City-sort-pointer-down",
    "Department-sort-pointer-up",
    "Department-sort-pointer-down",
  ]);
  const [MobileSortIds] = useState([
    "Employee-sort",
    "Country-sort",
    "City-sort",
    "Department-sort",
  ]);
  const [ResultIsEmpty, setResultIsEmpty] = useState(false);
  var PrevId = "";
  var PreviousModalId;

  const [PageInfo, setPageInfo] = useState({});

  useEffect(() => {
    fetchEmpList(0, 5);
    document.getElementById("Employee-sort").classList.add("active-sort");
  }, []);

  const fetchEmpList = (Start, Size) => {
    let Data = {
      criteria: {
        nameLike: document.getElementById("search-input").value,
      },
      size: Size,
      sorts: [
        {
          direction: "DESC",
          fieldName: "firstName",
        },
      ],
      start: Start,
    };

    if (
      document
        .getElementById("Employee-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Employee-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Employee-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            direction: "DESC",
            fieldName: "firstName",
          },
        ];
      } else {
        Data.sorts = [
          {
            direction: "ASC",
            fieldName: "firstName",
          },
        ];
      }
    }

    if (
      document
        .getElementById("Country-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Country-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Country-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            direction: "DESC",
            fieldName: "homeCountryCode",
          },
        ];
      } else {
        Data.sorts = [
          {
            direction: "ASC",
            fieldName: "homeCountryCode",
          },
        ];
      }
    }

    if (
      document
        .getElementById("City-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("City-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("City-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            direction: "DESC",
            fieldName: "homeCity",
          },
        ];
      } else {
        Data.sorts = [
          {
            direction: "ASC",
            fieldName: "homeCity",
          },
        ];
      }
    }

    if (
      document
        .getElementById("Department-sort-pointer-up")
        .classList.contains("active-filter") ||
      document
        .getElementById("Department-sort-pointer-down")
        .classList.contains("active-filter")
    ) {
      if (
        document
          .getElementById("Department-sort-pointer-up")
          .classList.contains("active-filter")
      ) {
        Data.sorts = [
          {
            direction: "DESC",
            fieldName: "assigns.position.department.name",
          },
        ];
      } else {
        Data.sorts = [
          {
            direction: "ASC",
            fieldName: "assigns.position.department.name",
          },
        ];
      }
    }

    if (TotalElements !== undefined && parseInt(Start) > TotalElements) {
      Start = parseInt(TotalElements - Size);
      Data.start = parseInt(TotalElements - Size);
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.EmpServiceURL + "/api/employee/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        updatePageCountInfo(Start, Size, Res.data.totalElements);
        console.log(Res);
        setTotalElements(Res.data.totalElements);
        createPageData(Res.data.results);
        createPagination(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          setResultIsEmpty(true);
          document.getElementById("info-footer").style.opacity = "0";
        } else {
          setResultIsEmpty(false);
          document.getElementById("info-footer").style.opacity = "1";
        }
        if (Res.data.totalElements <= Size) {
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const updatePageCountInfo = (Start, Size, totalElements) => {
    if (Start === 0) {
      document.getElementById("start").innerHTML = "1";
      document.getElementById("end").innerHTML = Size;
    } else {
      // document.getElementById("start").innerHTML = Start;
    }
    if (totalElements < parseInt(Start + Size) && totalElements !== 0) {
      document.getElementById("end").innerHTML = totalElements;
    } else {
      document.getElementById("end").innerHTML = parseInt(Start + Size);
    }
    if (parseInt(document.getElementById("end").innerHTML) === totalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    }
  };

  const createPageData = (Data) => {
    let Employees = [];

    Data.map((Item) => {
      let Team = [];
      if (Item.teams !== null) {
        Item.teams.map((Item) => {
          Team.push({
            firstName: Item.firstName,
            lastName: Item.lastName,
            colors: { bg: Item.backgroundColorCode, text: Item.textColorCode },
            imageThumbnailUrl: Item.imageThumbnailUrl,
          });
        });
      }
      Employees.push({
        firstName: Item.firstName,
        lastName: Item.lastName,
        position: Item.position,
        homeCountryCode: Item.homeCountryCode,
        homeCity: Item.homeCity,
        department: Item.department,
        teams: Team,
        id: Item.id,
        backgroundColorCode: Item.backgroundColorCode,
        textColorCode: Item.textColorCode,
        imageThumbnailUrl: Item.imageThumbnailUrl,
        manager: Item.manager ? `${Item.manager.firstName} ${Item.manager.lastName}` : null,
      });
    });
    setPageData(Employees);
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    fetchEmpList(NewStart, Size);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (parseInt(document.getElementById("end").innerHTML) === TotalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const createPagination = (TotalCount) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  // Opens and closes the small modal displayed for each row in the table based on conditions
  const openModal = (i) => {
    PrevId = i;

    if (PreviousModalId !== undefined) {
      if (document.getElementById("modal-" + i).style.display === "block") {
        document.getElementById("modal-" + i).style.display = "none";
      } else if (
        document.getElementById("modal-" + i).style.display === "none" &&
        PreviousModalId === "modal-" + i
      ) {
        document.getElementById("modal-" + i).style.display = "block";
      } else {
        document.getElementById("modal-" + i).style.display = "block";
        document.getElementById(PreviousModalId).style.display = "none";
      }
    } else {
      document.getElementById("modal-" + i).style.display = "block";
    }
    PreviousModalId = "modal-" + i;
  };

  const searchByName = () => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let Value = document.getElementById("search-input").value;
    fetchEmpList(0, Size);
    setTimeout(() => {
      if (document.getElementById("search-input").value.length === 0) {
        document.getElementById("end").innerHTML = Size;
      }
    }, 550);
  };

  const shortenPosName = (Name) => {
    if (window.innerWidth > 450) {
      if (Name.length <= 24) {
        return Name;
      } else {
        return Name.slice(0, 21) + " ...";
      }
    } else {
      if (Name.length <= 18) {
        return Name;
      } else {
        return Name.slice(0, 15) + " ...";
      }
    }
  };

  const shortenBigText = (Text) => {
    if (Text !== null) {
      if (Text.length <= 16) {
        return Text;
      } else {
        return Text.slice(0, 14) + " ...";
      }
    }
  };
  const handleFilterRequest = (Filter) => {
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let IsUp = false;
    if (
      document
        .getElementById(Filter + "-pointer-up")
        .classList.contains("active-filter")
    ) {
      IsUp = true;
    }

    FilterIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-filter");
    });
    if (IsUp) {
      document
        .getElementById(Filter + "-pointer-up")
        .classList.add("active-filter");
    } else {
      document
        .getElementById(Filter + "-pointer-down")
        .classList.add("active-filter");
    }
    let Start;
    if (document.getElementById("start").innerHTML === "1") {
      Start = parseInt(document.getElementById("start").innerHTML - 1);
    } else {
      Start = parseInt(document.getElementById("start").innerHTML - 1);
    }

    if (window.innerWidth <= 450) {
      MobileSortIds.map((Id) => {
        document.getElementById(Id).classList.remove("active-sort");
      });
      if (Filter === "Employee-sort") {
        document.getElementById("Employee-sort").classList.add("active-sort");
      }
      if (Filter === "Country-sort") {
        document.getElementById("Country-sort").classList.add("active-sort");
      }
      if (Filter === "City-sort") {
        document.getElementById("City-sort").classList.add("active-sort");
      }
      if (Filter === "Department-sort") {
        document.getElementById("Department-sort").classList.add("active-sort");
      }
    }

    fetchEmpList(Start, SelectedSize);
  };

  const resetFilters = () => {
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    document.getElementById("Employee-pointer-down").click();
  };
  const handleDropdown = (Id) => {
    document.getElementById(Id + "-trigger").click();
  };
  const addOpenState = (Id) => {
    document.getElementById(Id + "-icon").style.transform = "rotate(180deg)";
  };
  const removeOpenState = (Id) => {
    document.getElementById(Id + "-icon").style.transform = "none";
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const setSize = () => {
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  return (
    <BrowserRouter>
      <div className="main-content emp-pos-list">
        <Header PageName={translateText("employee_list")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("employees")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("employee_list")}</p>
          </div>
        </div>
        <div className="content-body">
          <SearchInput
            OnChange={() => searchByName()}
            Placeholder={translateText("search")}
          />
          <div className="info-wrapper">
            <section className="info-head emp-head">
              <TableFilter
                IsActive
                ChangeEvent={() => handleFilterRequest("Employee-sort")}
                Name={translateText("employee")}
                className="table-sort"
                Id="Employee-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("Country-sort")}
                Name={translateText("country")}
                className="table-sort"
                Id="Country-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("City-sort")}
                Name={translateText("city")}
                className="table-sort"
                Id="City-sort"
              />
              <TableFilter
                ChangeEvent={() => handleFilterRequest("Department-sort")}
                Name={translateText("department")}
                className="table-sort"
                Id="Department-sort"
              />
              <TableFilter
                ChangeEvent={() => null}
                Name={`Manager/${translateText("team")}`}
                className="table-sort"
                NoPointers
              />
              {/* <TableFilter
                ChangeEvent={() => null}
                Name={translateText("action")}
                NoPointers
                className="table-sort"
              /> */}
            </section>
            <React.Fragment>
              {ResultIsEmpty ? (
                <EmptyState
                  StateName="employee"
                  ResetFilters={() => resetFilters()}
                />
              ) : (
                <React.Fragment>
                  {PageData.map((Employee) => (
                    <div className="row-item emp-row">
                      <section className="emp-info emp">
                        {Employee.imageThumbnailUrl === null ? (
                          <React.Fragment>
                            <div
                              className="avatar-placeholder"
                              style={{
                                backgroundColor: Employee.backgroundColorCode,
                              }}
                            >
                              <p style={{ color: Employee.textColorCode }}>
                                {Employee.firstName.slice(0, 1).toUpperCase() +
                                  Employee.lastName.slice(0, 1).toUpperCase()}
                              </p>
                            </div>
                          </React.Fragment>
                        ) : (
                          <img
                            className="avatar"
                            alt=""
                            src={Employee.imageThumbnailUrl}
                          />
                        )}
                        <section className="grid-info">
                          <button
                            onClick={() => handleDropdown(Employee.id)}
                            className="info-trigger is-mobile"
                            id={Employee.id + "-icon"}
                          >
                            <i className="feather-chevron-down"></i>
                          </button>
                          <p className="emp-name">
                            {Employee.firstName + " " + Employee.lastName}
                          </p>
                          {Employee.position === null ? null : (
                            <p className="emp-pos">
                              {shortenPosName(Employee.position)}
                              <React.Fragment>
                                {window.innerWidth > 450 ? (
                                  <React.Fragment>
                                    {Employee.position.length > 24 ? (
                                      <p className="popup-text">
                                        {Employee.position}
                                      </p>
                                    ) : null}
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {Employee.position.length > 18 ? (
                                      <p className="popup-text">
                                        {Employee.position}
                                      </p>
                                    ) : null}
                                  </React.Fragment>
                                )}
                              </React.Fragment>
                            </p>
                          )}
                        </section>
                      </section>
                      {window.innerWidth > 450 ? (
                        <React.Fragment>
                          <section className="single-text">
                            {Employee.homeCountryCode === null ? ("N/A") : (
                              <p>{shortenBigText(Employee.homeCountryCode)}</p>
                            )}
                            {Employee.homeCountryCode !== null &&
                            Employee.homeCountryCode.length > 16 ? (
                              <p className="popup-text">
                                {Employee.homeCountryCode}
                              </p>
                            ) : null}
                          </section>
                          <section className="single-text">
                            {Employee.homeCity === null ? ("N/A") : (
                              <p>{shortenBigText(Employee.homeCity)}</p>
                            )}
                            {Employee.homeCity !== null &&
                            Employee.homeCity.length > 16 ? (
                              <p className="popup-text">{Employee.homeCity}</p>
                            ) : null}
                          </section>
                          <section className="single-text">
                            {Employee.department === null ? ("N/A") : (
                              <p>{shortenBigText(Employee.department)}</p>
                            )}
                            {Employee.department !== null ? (
                              <React.Fragment>
                                {Employee.department !== null &&
                                Employee.department.length > 16 ? (
                                  <p className="popup-text">
                                    {Employee.department}
                                  </p>
                                ) : null}
                              </React.Fragment>
                            ) : null}
                          </section>
                          <section className="single-text">
                            {Employee.manager === null ? ("N/A") : (
                                <p>{shortenBigText(Employee.manager)}</p>
                            )}
                            {Employee.manager !== null ? (
                                <React.Fragment>
                                  {Employee.manager !== null &&
                                  Employee.manager.length > 16 ? (
                                      <p className="popup-text">
                                        {Employee.manager}
                                      </p>
                                  ) : null}
                                </React.Fragment>
                            ) : null}
                          </section>

                          {Employee.manager && Employee.teams?.length !== 0 ?
                              <React.Fragment>
                                <section className="single-text">&nbsp;/&nbsp;</section>
                              </React.Fragment>
                              : null
                          }
                          <section className="team">
                            {Employee.teams === null ? ("N/A") : (
                              <React.Fragment>
                                <React.Fragment>
                                  {Employee.teams.map((TeamItem) => (
                                    <React.Fragment>
                                      <div className="team-wrapper">
                                        <div
                                          className="avatar-placeholder team-avatars"
                                          style={{
                                            backgroundColor: TeamItem.colors.bg,
                                          }}
                                        >
                                          {TeamItem.imageThumbnailUrl ===
                                          null ? (
                                            <p
                                              style={{
                                                color: TeamItem.colors.text,
                                              }}
                                            >
                                              {TeamItem.firstName
                                                .slice(0, 1)
                                                .toUpperCase() +
                                                TeamItem.lastName
                                                  .slice(0, 1)
                                                  .toUpperCase()}
                                            </p>
                                          ) : (
                                            <img
                                              className="avatar"
                                              alt=""
                                              src={TeamItem.imageThumbnailUrl}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  ))}
                                  {Employee.teams.length > 3 ? (
                                    <button className="more">
                                      {"+" +
                                        parseInt(Employee.teams.length - 3)}
                                    </button>
                                  ) : null}
                                </React.Fragment>
                              </React.Fragment>
                            )}
                          </section>
                          {/* <section className="action">
                            <button
                              className="more"
                              onClick={() => openModal(Employee.id)}
                            ></button>
                            <div
                              className="modal-space"
                              id={"modal-" + Employee.id}
                            >
                              <div
                                className="outline"
                                onClick={() => openModal(PrevId)}
                              ></div>
                              <div className="modal-body double-item">
                                <button className="btn">
                                  <img alt="" src={Pencil} />
                                  <div className="btn-text">
                                    <p>{translateText("action")}</p>
                                    <p>{translateText("action")}</p>
                                  </div>
                                </button>
                                <button className="btn">
                                  <img alt="" src={Pencil} />
                                  <div className="btn-text">
                                    <p>{translateText("action")}</p>
                                    <p>{translateText("action")}</p>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </section> */}
                        </React.Fragment>
                      ) : (
                        <Collapsible
                          trigger={
                            <button
                              className="hidden"
                              id={Employee.id + "-trigger"}
                            ></button>
                          }
                          onOpening={() => addOpenState(Employee.id)}
                          onClosing={() => removeOpenState(Employee.id)}
                        >
                          <section className="single-text">
                            <p className="is-mobile">
                              {translateText("country")}
                            </p>
                            {Employee.homeCountryCode === null ? ("N/A") : (
                              <p>
                                {shortenBigText(Employee.homeCountryCode)}
                                {Employee.homeCountryCode.length > 16 ? (
                                  <p className="popup-text">
                                    {Employee.homeCountryCode}
                                  </p>
                                ) : null}
                              </p>
                            )}
                          </section>
                          <section className="single-text">
                            <p className="is-mobile">{translateText("city")}</p>
                            {Employee.homeCity === null ? ("N/A") : (
                              <p>
                                {shortenBigText(Employee.homeCity)}
                                {Employee.homeCity.length > 16 ? (
                                  <p className="popup-text">
                                    {Employee.homeCity}
                                  </p>
                                ) : null}
                              </p>
                            )}
                          </section>
                          <section className="single-text">
                            <p className="is-mobile">
                              {translateText("department")}
                            </p>
                            {Employee.department === null ? ("N/A") : (
                              <p>{shortenBigText(Employee.department)}</p>
                            )}
                            {Employee.department !== null ? (
                              <React.Fragment>
                                {Employee.department.length > 16 ? (
                                  <p className="popup-text">
                                    {Employee.department}
                                  </p>
                                ) : null}
                              </React.Fragment>
                            ) : null}
                          </section>
                          <section className="single-text">
                            <p className="is-mobile">
                              {/*TODO: need translation for manager*/}
                              Manager
                            </p>
                            {Employee.manager ? <p>{shortenBigText(Employee.manager)}</p> : ("N/A")}
                            {Employee.manager ? (
                                <React.Fragment>
                                  {Employee.manager.length > 16 ? (
                                      <p className="popup-text">
                                        {Employee.manager}
                                      </p>
                                  ) : null}
                                </React.Fragment>
                            ) : null}
                          </section>
                          <section className="team">
                            <p className="is-mobile">{translateText("team")}</p>
                            {Employee.teams === null ? ("N/A") : (
                              <React.Fragment>
                                <React.Fragment>
                                  {Employee.teams.map((TeamItem) => (
                                    <React.Fragment>
                                      {TeamItem.image ? (
                                        <img
                                          className="avatar"
                                          alt=""
                                          src={TeamItem.image}
                                        />
                                      ) : (
                                        <div className="team-wrapper">
                                          <div
                                            className="avatar-placeholder team-avatars"
                                            style={{
                                              backgroundColor:
                                                TeamItem.colors.bg,
                                            }}
                                          >
                                            <p
                                              style={{
                                                color: TeamItem.colors.text,
                                              }}
                                            >
                                              {TeamItem.firstName
                                                .slice(0, 1)
                                                .toUpperCase() +
                                                TeamItem.lastName
                                                  .slice(0, 1)
                                                  .toUpperCase()}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ))}
                                  {Employee.teams.length > 3 ? (
                                    <button className="more">
                                      {"+" +
                                        parseInt(Employee.teams.length - 3)}
                                    </button>
                                  ) : null}
                                </React.Fragment>
                              </React.Fragment>
                            )}
                          </section>
                          {/* <section className="action">
                            <p className="is-mobile">
                              {translateText("action")}
                            </p>
                            <button
                              className="more"
                              onClick={() => openModal(Employee.id)}
                            ></button>
                          </section> */}
                        </Collapsible>
                      )}
                      <div
                        className="modal-space is-mobile"
                        id={"modal-" + Employee.id}
                      >
                        <div
                          className="outline"
                          onClick={() => openModal(PrevId)}
                        ></div>
                        <div className="modal-body double-item">
                          <button className="btn">
                            <img alt="" src={Pencil} />
                            <div className="btn-text">
                              <p>{translateText("action")}</p>
                              <p>{translateText("action")}</p>
                            </div>
                          </button>
                          <button className="btn">
                            <img alt="" src={Pencil} />
                            <div className="btn-text">
                              <p>{translateText("action")}</p>
                              <p>{translateText("action")}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              )}
            </React.Fragment>
          </div>
          <div className="info-footer" id="info-footer">
            <div className="pagenumber-summary">
              {translateText("showing")} <p id="start">1</p>
              {translateText("to")} <p id="end">5</p>
              {translateText("of")} {TotalElements} {translateText("items")}.
            </div>
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className="page-btn page-btn-disabled"
              >
                <i className="feather-chevron-left"></i>
              </button>
              <React.Fragment>
                {Pages.length < 6 ? (
                  <React.Fragment>
                    {Pages.map((Page) => (
                      <React.Fragment>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </React.Fragment>
                )}
              </React.Fragment>
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn"
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <div className="row-count-select">
              <p className="row-info">{translateText("rows_per_page")}</p>
              <Select
                Initial={"5"}
                Options={SizeOptions}
                IsWithId
                Id={"row-per-page"}
                ChangeHandler={() =>
                  setTimeout(() => {
                    setSize();
                  }, 100)
                }
                ValidationError=""
              />
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default EmployeesList;
